module.exports = __webpack_public_path__ + "img/estate.a97c84e9.png";